import React, { createContext, useContext, useState, useEffect, useCallback, useRef } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const I18nContext = createContext(null);

const translations = {
  es: {
    // Navigation
    home: 'Inicio',
    explore: 'Explorar',
    map: 'Mapa',
    search: 'Buscar',
    login: 'Iniciar Sesión',
    register: 'Registrarse',
    logout: 'Cerrar Sesión',
    dashboard: 'Panel',
    myEvents: 'Mis Eventos',
    profile: 'Perfil',
    // Territory
    selectCountry: 'Selecciona País',
    selectRegion: 'Selecciona Región',
    selectCommune: 'Selecciona Comuna',
    allRegions: 'Todas las regiones',
    allCommunes: 'Todas las comunas',
    // Date filters
    today: 'Hoy',
    tomorrow: 'Mañana',
    weekend: 'Fin de semana',
    customRange: 'Rango personalizado',
    // Events
    featuredEvents: 'Panoramas Destacados',
    whatsHappeningToday: 'Lo que está pasando hoy',
    whatsHappeningTodaySubtitle: 'Eventos y actividades disponibles para disfrutar hoy mismo',
    allEvents: 'Todos los Eventos',
    noEvents: 'No hay eventos disponibles',
    freeEvent: 'Gratis',
    viewMore: 'Ver más',
    viewAll: 'Ver todos',
    viewDetails: 'Ver detalles',
    viewAllEvents: 'Ver todos sus eventos',
    shareEvent: 'Compartir',
    contactOrganizer: 'Contactar organizador',
    exploreEvents: 'Explorar eventos',
    searchEvents: 'Buscar eventos...',
    eventsFound: 'eventos encontrados',
    noEventsFound: 'No se encontraron eventos',
    tryAdjustingFilters: 'Intenta ajustar los filtros de búsqueda',
    // Filters
    filters: 'Filtros',
    category: 'Categoría',
    allCategories: 'Todas las categorías',
    price: 'Precio',
    free: 'Gratuito',
    paid: 'De pago',
    audience: 'Público',
    kids: 'Niños',
    adults: 'Adultos',
    family: 'Familiar',
    allAudiences: 'Todos los públicos',
    clearFilters: 'Limpiar filtros',
    applyFilters: 'Aplicar',
    // Event detail
    schedule: 'Horario',
    address: 'Dirección',
    howToGet: 'Cómo llegar',
    faq: 'Preguntas Frecuentes',
    ratings: 'Valoraciones',
    rateEvent: 'Valorar evento',
    eventInfo: 'Información del evento',
    organizer: 'Organizador',
    dateAndTime: 'Fecha y hora',
    location: 'Ubicación',
    targetAudience: 'Público objetivo',
    priceInfo: 'Precio',
    // Badges
    verified: 'Verificado',
    activeOrganizer: 'Org. activo',
    notVerified: 'Sin verificar',
    // Auth
    email: 'Correo electrónico',
    password: 'Contraseña',
    name: 'Nombre',
    businessName: 'Nombre del negocio',
    loginAsProvider: 'Soy organizador/comercio',
    loginTitle: 'Iniciar sesión',
    registerTitle: 'Crear cuenta',
    noAccount: '¿No tienes cuenta?',
    hasAccount: '¿Ya tienes cuenta?',
    // Provider
    createEvent: 'Crear Evento',
    editEvent: 'Editar',
    deleteEvent: 'Eliminar',
    eventName: 'Nombre del evento',
    description: 'Descripción',
    shortDescription: 'Descripción corta',
    startDate: 'Fecha inicio',
    endDate: 'Fecha término',
    providerDashboard: 'Panel del Proveedor',
    // Admin
    pendingApproval: 'Pendientes de aprobación',
    approve: 'Aprobar',
    reject: 'Rechazar',
    users: 'Usuarios',
    providers: 'Proveedores',
    categories: 'Categorías',
    statistics: 'Estadísticas',
    adminPanel: 'Panel de Administración',
    // Landing
    heroTitle: 'PlanCity, lo que está pasando.',
    heroSubtitle: 'Panoramas, eventos y experiencias locales en un solo lugar',
    categoriesTitle: 'Categorías',
    categoriesSubtitle: 'Explora por categoría y encuentra lo que buscas',
    providerCTA: '¿Eres organizador o tienes un comercio?',
    providerCTASubtitle: 'Publica tus eventos y conecta con la comunidad',
    providerCTAButton: 'Registra tu negocio',
    // General
    loading: 'Cargando...',
    error: 'Error',
    success: 'Éxito',
    save: 'Guardar',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    delete: 'Eliminar',
    close: 'Cerrar',
    back: 'Volver',
    next: 'Siguiente',
    from: 'Desde',
    to: 'Hasta',
    of: 'de',
    noDate: 'Sin fecha',
    // Footer
    aboutPlatform: 'Plataforma de eventos locales',
    quickLinks: 'Enlaces rápidos',
    legal: 'Legal',
    privacyPolicy: 'Política de privacidad',
    termsOfService: 'Términos de servicio',
    allRightsReserved: 'Todos los derechos reservados'
  },
  en: {
    home: 'Home',
    explore: 'Explore',
    map: 'Map',
    search: 'Search',
    login: 'Login',
    register: 'Register',
    logout: 'Logout',
    dashboard: 'Dashboard',
    myEvents: 'My Events',
    profile: 'Profile',
    selectCountry: 'Select Country',
    selectRegion: 'Select Region',
    selectCommune: 'Select Commune',
    allRegions: 'All regions',
    allCommunes: 'All communes',
    today: 'Today',
    tomorrow: 'Tomorrow',
    weekend: 'Weekend',
    customRange: 'Custom range',
    featuredEvents: 'Featured Events',
    whatsHappeningToday: "What's happening today",
    whatsHappeningTodaySubtitle: 'Events and activities available to enjoy today',
    allEvents: 'All Events',
    noEvents: 'No events available',
    freeEvent: 'Free',
    viewMore: 'View more',
    viewAll: 'View all',
    viewDetails: 'View details',
    viewAllEvents: 'View all their events',
    shareEvent: 'Share',
    contactOrganizer: 'Contact organizer',
    exploreEvents: 'Explore events',
    searchEvents: 'Search events...',
    eventsFound: 'events found',
    noEventsFound: 'No events found',
    tryAdjustingFilters: 'Try adjusting your search filters',
    filters: 'Filters',
    category: 'Category',
    allCategories: 'All categories',
    price: 'Price',
    free: 'Free',
    paid: 'Paid',
    audience: 'Audience',
    kids: 'Kids',
    adults: 'Adults',
    family: 'Family',
    allAudiences: 'All audiences',
    clearFilters: 'Clear filters',
    applyFilters: 'Apply',
    schedule: 'Schedule',
    address: 'Address',
    howToGet: 'How to get there',
    faq: 'FAQ',
    ratings: 'Ratings',
    rateEvent: 'Rate event',
    eventInfo: 'Event information',
    organizer: 'Organizer',
    dateAndTime: 'Date and time',
    location: 'Location',
    targetAudience: 'Target audience',
    priceInfo: 'Price',
    verified: 'Verified',
    activeOrganizer: 'Active org.',
    notVerified: 'Not verified',
    email: 'Email',
    password: 'Password',
    name: 'Name',
    businessName: 'Business name',
    loginAsProvider: "I'm an organizer/business",
    loginTitle: 'Login',
    registerTitle: 'Create account',
    noAccount: "Don't have an account?",
    hasAccount: 'Already have an account?',
    createEvent: 'Create Event',
    editEvent: 'Edit',
    deleteEvent: 'Delete',
    eventName: 'Event name',
    description: 'Description',
    shortDescription: 'Short description',
    startDate: 'Start date',
    endDate: 'End date',
    providerDashboard: 'Provider Dashboard',
    pendingApproval: 'Pending approval',
    approve: 'Approve',
    reject: 'Reject',
    users: 'Users',
    providers: 'Providers',
    categories: 'Categories',
    statistics: 'Statistics',
    adminPanel: 'Admin Panel',
    heroTitle: 'PlanCity, what\'s happening.',
    heroSubtitle: 'Local events, activities and experiences in one place',
    categoriesTitle: 'Categories',
    categoriesSubtitle: 'Explore by category and find what you\'re looking for',
    providerCTA: 'Are you an organizer or business owner?',
    providerCTASubtitle: 'Publish your events and connect with the community',
    providerCTAButton: 'Register your business',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    save: 'Save',
    cancel: 'Cancel',
    confirm: 'Confirm',
    delete: 'Delete',
    close: 'Close',
    back: 'Back',
    next: 'Next',
    from: 'From',
    to: 'To',
    of: 'of',
    noDate: 'No date',
    aboutPlatform: 'Local events platform',
    quickLinks: 'Quick links',
    legal: 'Legal',
    privacyPolicy: 'Privacy policy',
    termsOfService: 'Terms of service',
    allRightsReserved: 'All rights reserved'
  },
  pt: {
    home: 'Início',
    explore: 'Explorar',
    map: 'Mapa',
    search: 'Buscar',
    login: 'Entrar',
    register: 'Registrar',
    logout: 'Sair',
    dashboard: 'Painel',
    myEvents: 'Meus Eventos',
    profile: 'Perfil',
    selectCountry: 'Selecione País',
    selectRegion: 'Selecione Região',
    selectCommune: 'Selecione Comuna',
    allRegions: 'Todas as regiões',
    allCommunes: 'Todas as comunas',
    today: 'Hoje',
    tomorrow: 'Amanhã',
    weekend: 'Fim de semana',
    customRange: 'Intervalo personalizado',
    featuredEvents: 'Eventos em Destaque',
    whatsHappeningToday: 'O que está acontecendo hoje',
    whatsHappeningTodaySubtitle: 'Eventos e atividades disponíveis para aproveitar hoje',
    allEvents: 'Todos os Eventos',
    noEvents: 'Sem eventos disponíveis',
    freeEvent: 'Grátis',
    viewMore: 'Ver mais',
    viewAll: 'Ver todos',
    viewDetails: 'Ver detalhes',
    viewAllEvents: 'Ver todos os eventos',
    shareEvent: 'Compartilhar',
    contactOrganizer: 'Contato',
    exploreEvents: 'Explorar eventos',
    searchEvents: 'Buscar eventos...',
    eventsFound: 'eventos encontrados',
    noEventsFound: 'Nenhum evento encontrado',
    tryAdjustingFilters: 'Tente ajustar os filtros de busca',
    filters: 'Filtros',
    category: 'Categoria',
    allCategories: 'Todas as categorias',
    price: 'Preço',
    free: 'Gratuito',
    paid: 'Pago',
    audience: 'Público',
    kids: 'Crianças',
    adults: 'Adultos',
    family: 'Familiar',
    allAudiences: 'Todos os públicos',
    clearFilters: 'Limpar filtros',
    applyFilters: 'Aplicar',
    schedule: 'Horário',
    address: 'Endereço',
    howToGet: 'Como chegar',
    faq: 'Perguntas Frequentes',
    ratings: 'Avaliações',
    rateEvent: 'Avaliar evento',
    eventInfo: 'Informações do evento',
    organizer: 'Organizador',
    dateAndTime: 'Data e horário',
    location: 'Localização',
    targetAudience: 'Público-alvo',
    priceInfo: 'Preço',
    verified: 'Verificado',
    activeOrganizer: 'Org. ativo',
    notVerified: 'Não verificado',
    email: 'Email',
    password: 'Senha',
    name: 'Nome',
    businessName: 'Nome do negócio',
    loginAsProvider: 'Sou organizador/empresa',
    loginTitle: 'Entrar',
    registerTitle: 'Criar conta',
    noAccount: 'Não tem conta?',
    hasAccount: 'Já tem conta?',
    createEvent: 'Criar Evento',
    editEvent: 'Editar',
    deleteEvent: 'Excluir',
    eventName: 'Nome do evento',
    description: 'Descrição',
    shortDescription: 'Descrição curta',
    startDate: 'Data início',
    endDate: 'Data término',
    providerDashboard: 'Painel do Fornecedor',
    pendingApproval: 'Pendente de aprovação',
    approve: 'Aprovar',
    reject: 'Rejeitar',
    users: 'Usuários',
    providers: 'Fornecedores',
    categories: 'Categorias',
    statistics: 'Estatísticas',
    adminPanel: 'Painel de Administração',
    heroTitle: 'PlanCity, o que está acontecendo.',
    heroSubtitle: 'Eventos, atividades e experiências locais em um só lugar',
    categoriesTitle: 'Categorias',
    categoriesSubtitle: 'Explore por categoria e encontre o que procura',
    providerCTA: 'É organizador ou tem um negócio?',
    providerCTASubtitle: 'Publique seus eventos e conecte-se com a comunidade',
    providerCTAButton: 'Registre seu negócio',
    loading: 'Carregando...',
    error: 'Erro',
    success: 'Sucesso',
    save: 'Salvar',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    delete: 'Excluir',
    close: 'Fechar',
    back: 'Voltar',
    next: 'Próximo',
    from: 'De',
    to: 'Até',
    of: 'de',
    noDate: 'Sem data',
    aboutPlatform: 'Plataforma de eventos locais',
    quickLinks: 'Links rápidos',
    legal: 'Legal',
    privacyPolicy: 'Política de privacidade',
    termsOfService: 'Termos de serviço',
    allRightsReserved: 'Todos os direitos reservados'
  }
};

export const useI18n = () => {
  const context = useContext(I18nContext);
  if (!context) throw new Error('useI18n must be used within I18nProvider');
  return context;
};

// =====================================================================
// Module-level shared translation cache. Shared across ALL components
// that call useTranslate(). Persisted to localStorage. Subscribers are
// notified whenever the cache changes so every card re-renders together.
// =====================================================================
const SHARED_CACHE = (() => {
  try {
    const saved = localStorage.getItem('plancity_translations');
    return saved ? JSON.parse(saved) : {};
  } catch { return {}; }
})();
const SHARED_PENDING = new Set();
let sharedTimer = null;
const subscribers = new Set();
let sharedLocale = (typeof window !== 'undefined' && localStorage.getItem('locale')) || 'es';

const saveSharedCache = () => {
  try {
    localStorage.setItem('plancity_translations', JSON.stringify(SHARED_CACHE));
  } catch { /* ignore */ }
};

const notifySubscribers = () => {
  subscribers.forEach((fn) => {
    try { fn(); } catch { /* ignore */ }
  });
};

const flushSharedPending = async () => {
  if (SHARED_PENDING.size === 0) return;
  const texts = [...SHARED_PENDING];
  SHARED_PENDING.clear();
  const targetLang = sharedLocale;
  try {
    const response = await axios.post(`${API_URL}/api/translate/batch`, {
      texts,
      target_lang: targetLang,
    });
    const { translations: result } = response.data || {};
    if (result) {
      for (const [original, translated] of Object.entries(result)) {
        SHARED_CACHE[`${targetLang}:${original}`] = translated;
      }
      saveSharedCache();
      notifySubscribers();
    }
  } catch (error) {
    console.error('Translation batch failed:', error);
  }
};

// Dynamic content translation hook (uses the shared cache above)
export const useTranslate = () => {
  const { locale } = useI18n();
  const [, forceUpdate] = useState(0);

  // Keep sharedLocale in sync
  useEffect(() => {
    sharedLocale = locale;
  }, [locale]);

  // Subscribe to cache updates
  useEffect(() => {
    const sub = () => forceUpdate((n) => n + 1);
    subscribers.add(sub);
    return () => { subscribers.delete(sub); };
  }, []);

  const translateText = useCallback((text) => {
    if (!text || locale === 'es') return text;
    const key = `${locale}:${text}`;
    if (SHARED_CACHE[key]) return SHARED_CACHE[key];
    // Queue for batch translation
    SHARED_PENDING.add(text);
    if (sharedTimer) clearTimeout(sharedTimer);
    sharedTimer = setTimeout(flushSharedPending, 150);
    return text;
  }, [locale]);

  // Batch translate an array of texts immediately (awaits result)
  const translateBatch = useCallback(async (texts) => {
    if (!texts?.length || locale === 'es') return texts;
    const uncached = texts.filter((t) => t && !SHARED_CACHE[`${locale}:${t}`]);
    if (uncached.length > 0) {
      try {
        const response = await axios.post(`${API_URL}/api/translate/batch`, {
          texts: uncached,
          target_lang: locale,
        });
        for (const [original, translated] of Object.entries(response.data?.translations || {})) {
          SHARED_CACHE[`${locale}:${original}`] = translated;
        }
        saveSharedCache();
        notifySubscribers();
      } catch (error) {
        console.error('Batch translate failed:', error);
      }
    }
    return texts.map((t) => SHARED_CACHE[`${locale}:${t}`] || t);
  }, [locale]);

  return { translateText, translateBatch, locale };
};

export const I18nProvider = ({ children }) => {
  const [locale, setLocale] = useState(() => {
    return localStorage.getItem('locale') || 'es';
  });

  useEffect(() => {
    localStorage.setItem('locale', locale);
  }, [locale]);

  const t = (key) => {
    return translations[locale]?.[key] || translations.es[key] || key;
  };

  const changeLocale = (newLocale) => {
    if (translations[newLocale]) {
      setLocale(newLocale);
    }
  };

  return (
    <I18nContext.Provider value={{ locale, t, changeLocale, locales: ['es', 'en', 'pt'] }}>
      {children}
    </I18nContext.Provider>
  );
};
